const ADMIN_INVOICES = {
  SET_INVOICES_QUERY: 'SET_ADMIN_INVOICES_QUERY',
};

export default ADMIN_INVOICES;
